/* TRNK& DIY touches */
(function () {
    var body = document.body;
    // Cards added later (the link feed) call this to get their hover brushes.
    window.trnkBindCards = function () {};
    if (!body.classList.contains('has-brush-art')) return;

    function rand(min, max) {
        return min + Math.random() * (max - min);
    }

    function pick(list) {
        return list[Math.floor(Math.random() * list.length)];
    }

    // Wrap “prefect.” in the slogan so the hand-drawn line can sit under it.
    // Keeps the deliberate “prefect” wordplay; does nothing when the slogan changes.
    var intro = document.querySelector('.trnk-intro');
    if (intro) {
        var text = intro.textContent;
        var match = /\bprefect\./.exec(text);
        if (match) {
            var word = document.createElement('span');
            word.className = 'trnk-handword';
            word.textContent = match[0];
            intro.replaceChildren(
                document.createTextNode(text.slice(0, match.index)),
                word,
                document.createTextNode(text.slice(match.index + match[0].length))
            );
            intro.classList.add('has-handword');
        }
    }

    // Every article keeps its own brush (picked from the slug), only the exact spot changes per visit.
    var variants = ['star', 'figure', 'squiggle', 'line'];
    document.querySelectorAll('[data-trnk-art]').forEach(function (el) {
        var slug = el.getAttribute('data-trnk-art') || '';
        var hash = 0;
        for (var i = 0; i < slug.length; i++) {
            hash = (hash * 31 + slug.charCodeAt(i)) >>> 0;
        }
        el.classList.add('is-' + variants[hash % variants.length]);
    });

    // Hand-placed feel: nudge every brush a little on each page load.
    // Offsets are % of the brush itself, so they stay proportional on mobile.
    // Small ranges on purpose: the headline brush stays with the headline.
    document.querySelectorAll('.trnk-art').forEach(function (el) {
        var isLine = el.classList.contains('is-line');
        el.style.setProperty('--trnk-dx', rand(isLine ? -4 : -14, isLine ? 10 : 14).toFixed(1) + '%');
        el.style.setProperty('--trnk-dy', rand(isLine ? -6 : -8, isLine ? 6 : 6).toFixed(1) + '%');
        el.style.setProperty('--trnk-dr', rand(isLine ? -2 : -10, isLine ? 2 : 10).toFixed(1) + 'deg');
    });

    // Lead image brush: random spot along the bottom edge of the photo.
    var leadVisual = document.querySelector('.trnk-lead-visual:not(.trnk-type-art)');
    if (leadVisual) {
        leadVisual.style.setProperty('--trnk-sx', rand(4, 58).toFixed(1) + '%');
        leadVisual.style.setProperty('--trnk-sr', rand(-16, 6).toFixed(1) + 'deg');
    }

    // Post cards: a new brush at a new spot every time you hover.
    // The headline turns green on hover, so the brush lands under it (behind excerpt and date), never behind it.
    var cardBrushes = [
        {img: 'var(--trnk-brush-squiggle)', ratio: '285 / 157', width: [130, 190]},
        {img: 'var(--trnk-brush-star)', ratio: '697 / 325', width: [170, 230]},
        {img: 'var(--trnk-brush-hatch)', ratio: '542 / 166', width: [170, 230]},
        {img: 'var(--trnk-brush-line)', ratio: '427 / 114', width: [170, 230]}
    ];

    function landBrush(wrapper) {
        var brush = pick(cardBrushes);
        wrapper.style.setProperty('--trnk-cimg', brush.img);
        wrapper.style.setProperty('--trnk-ca', brush.ratio);
        wrapper.style.setProperty('--trnk-cw', Math.round(rand(brush.width[0], brush.width[1])) + 'px');
        wrapper.style.setProperty('--trnk-cx', rand(-2, 55).toFixed(1) + '%');
        wrapper.style.setProperty('--trnk-cy', rand(34, 62).toFixed(1) + '%');
        wrapper.style.setProperty('--trnk-cr', rand(-14, 10).toFixed(1) + 'deg');
    }

    function bindCards(root) {
        (root || document).querySelectorAll('.gh-card-link').forEach(function (link) {
            var wrapper = link.querySelector('.gh-card-wrapper');
            if (!wrapper || link.hasAttribute('data-trnk-brush')) return;
            link.setAttribute('data-trnk-brush', '');
            landBrush(wrapper);
            link.addEventListener('mouseenter', function () {
                landBrush(wrapper);
            });
            link.addEventListener('focus', function () {
                landBrush(wrapper);
            });
        });
    }

    bindCards(document);
    window.trnkBindCards = bindCards;
}());
